import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "KRISummarySubmissionModeler" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
